export default __webpack_public_path__ + "static/media/Avatar-22.c5604eda.png";